/**
 * Clean Glow Landing Page JavaScript
 * Bundle selection, countdown timer, before/after slider, FAQ, reviews, Shopify cart integration
 */

(function() {
  'use strict';

  if (window.__bbeLpCleanGlowLoaded) {
    const initExisting = window.__bbeLpCleanGlowInit;
    const currentScript = document.currentScript;
    if (typeof initExisting === 'function') {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => initExisting(currentScript), { once: true });
      } else {
        initExisting(currentScript);
      }
    }
    return;
  }
  window.__bbeLpCleanGlowLoaded = true;

  let curBundle = 2;
  let curShade = '';
  let activeCleanGlowRoot = null;
  let cleanGlowRootSeq = 0;
  const CLEAN_GLOW_SECTION_SELECTOR = '.shopify-section.lp-clean-glow, .lp-clean-glow';
  const sectionState = new WeakMap();
  const documentState = { bundle: curBundle, shade: curShade };
  const stickySummaryState = new Map();
  let headerVisibilityState = null;

  function ensureRootKey(root) {
    if (!root || root === document || !root.dataset) return root || document;
    if (!root.dataset.lpCleanGlowRoot) {
      cleanGlowRootSeq += 1;
      root.dataset.lpCleanGlowRoot = `lp-clean-glow-${cleanGlowRootSeq}`;
    }
    return root;
  }

  function getRootByKey(key) {
    if (!key) return null;
    const roots = document.querySelectorAll(CLEAN_GLOW_SECTION_SELECTOR);
    for (const root of roots) {
      if (root.dataset.lpCleanGlowRoot === key) return root;
    }
    return null;
  }

  function getElementIdSelector(id) {
    const cleanId = String(id || '').replace(/^#/, '').trim();
    if (!cleanId) return '';
    if (window.CSS && typeof window.CSS.escape === 'function') return `#${window.CSS.escape(cleanId)}`;
    return `#${escapeCssIdentForSelector(cleanId)}`;
  }

  /** Escape an HTML id for `#id` selectors when `CSS.escape` is unavailable. */
  function escapeCssIdentForSelector(ident) {
    const s = String(ident || '');
    let out = '';
    for (let i = 0; i < s.length; i += 1) {
      const c = s[i];
      const code = s.charCodeAt(i);
      if (code === 0) {
        out += '\ufffd';
        continue;
      }
      if (code <= 31 || code === 127) continue;
      if (/^[0-9]$/.test(c) && i === 0) {
        out += '\\3' + c + ' ';
        continue;
      }
      if (/^[a-zA-Z0-9_-]$/.test(c)) {
        out += c;
        continue;
      }
      out += '\\' + c;
    }
    return out;
  }

  function findByIdWithin(root, id) {
    if (!root || !root.querySelector) return null;
    const cleanId = String(id || '').replace(/^#/, '').trim();
    if (!cleanId) return null;

    const selector = getElementIdSelector(cleanId);
    if (selector) {
      try {
        return root.querySelector(selector);
      } catch (_e) {
        /* fall through to [id] walk */
      }
    }

    const allIds = root.querySelectorAll('[id]');
    for (const el of allIds) {
      if (el.id === cleanId) return el;
    }
    return null;
  }

  function getSectionRoot(source) {
    if (source && source.closest) {
      const root = source.closest(CLEAN_GLOW_SECTION_SELECTOR);
      if (root) {
        activeCleanGlowRoot = ensureRootKey(root);
        return activeCleanGlowRoot;
      }

      const sticky = source.closest('.sticky-bar');
      const stickyRoot = sticky && getRootByKey(sticky.dataset.lpCleanGlowRoot);
      if (stickyRoot) {
        activeCleanGlowRoot = ensureRootKey(stickyRoot);
        return activeCleanGlowRoot;
      }
    }

    if (activeCleanGlowRoot && document.contains(activeCleanGlowRoot)) return activeCleanGlowRoot;
    const firstRoot = document.querySelector(CLEAN_GLOW_SECTION_SELECTOR);
    activeCleanGlowRoot = firstRoot ? ensureRootKey(firstRoot) : document;
    return activeCleanGlowRoot;
  }

  function normalizeRoot(root) {
    if (root && root !== document && root.querySelector) {
      activeCleanGlowRoot = ensureRootKey(root);
      return activeCleanGlowRoot;
    }
    return getSectionRoot();
  }

  function getSectionRoots() {
    const roots = [];
    document.querySelectorAll(CLEAN_GLOW_SECTION_SELECTOR).forEach((root) => {
      if (!root.querySelector('.bundle-card, .shade-card, .sticky-bar')) return;
      const keyedRoot = ensureRootKey(root);
      if (!roots.includes(keyedRoot)) roots.push(keyedRoot);
    });
    if (!roots.length && document.querySelector('.bundle-card, .shade-card')) roots.push(document);
    return roots;
  }

  function getInitScopeRoots(container) {
    if (!container || container.nodeType !== 1) return null;
    const found = [];
    if (container.matches && container.matches(CLEAN_GLOW_SECTION_SELECTOR)) {
      found.push(ensureRootKey(container));
      return found;
    }
    container.querySelectorAll(CLEAN_GLOW_SECTION_SELECTOR).forEach((el) => {
      const r = ensureRootKey(el);
      if (!found.includes(r)) found.push(r);
    });
    if (found.length) return found;
    getSectionRoots().forEach((r) => {
      if (r !== document && container.contains(r) && !found.includes(r)) found.push(r);
    });
    return found.length ? found : null;
  }

  function querySelectorAllInRoots(roots, selector) {
    const out = [];
    if (!roots || !roots.length) return out;
    roots.forEach((root) => {
      const base = root === document ? document : root;
      base.querySelectorAll(selector).forEach((el) => {
        if (!out.includes(el)) out.push(el);
      });
    });
    return out;
  }

  function bindAtcButtonsForRoot(root) {
    const scopedRoot = normalizeRoot(root);
    if (scopedRoot === document) {
      document.querySelectorAll('#main-atc, #sticky-atc').forEach(function (btn) {
        if (!btn || btn.dataset.lpAtcBound === '1') return;
        btn.dataset.lpAtcBound = '1';
        btn.addEventListener('click', addToCart);
      });
      return;
    }
    ['#main-atc', '#sticky-atc'].forEach(function (sel) {
      const btn = scopedQuery(scopedRoot, sel);
      if (!btn || btn.dataset.lpAtcBound === '1') return;
      btn.dataset.lpAtcBound = '1';
      btn.addEventListener('click', addToCart);
    });
  }

  function getState(root) {
    const scopedRoot = normalizeRoot(root);
    if (scopedRoot === document) return documentState;
    let state = sectionState.get(scopedRoot);
    if (!state) {
      state = { bundle: curBundle, shade: curShade };
      sectionState.set(scopedRoot, state);
    }
    return state;
  }

  // ─── BUNDLE TIER CONFIG (schema → Liquid → data-*) ───
  // Populated per section root by initBundlesFromSchema() from each .bundle-card’s
  // data-qty, data-pct-display, and data-discount (theme editor). No hardcoded tiers.
  function getBundleTiers(root) {
    const scopedRoot = normalizeRoot(root);
    const state = getState(scopedRoot);
    if (!state.bundleTiers) state.bundleTiers = {};
    return state.bundleTiers;
  }

  function initBundlesFromSchema(root) {
    const scopedRoot = normalizeRoot(root);
    const state = getState(scopedRoot);
    const tiers = {};
    scopedRoot.querySelectorAll('.bundle-card[data-bundle]').forEach((card) => {
      const key = String(card.dataset.bundle || '').trim();
      if (!key) return;

      const qtyAttr = parseInt(card.dataset.qty, 10);
      const pctAttr = parseInt(card.dataset.pctDisplay, 10);
      const qty = Number.isFinite(qtyAttr) && qtyAttr > 0 ? qtyAttr : parseInt(key, 10) || 1;
      const pct = Number.isFinite(pctAttr) && pctAttr >= 0 ? pctAttr : 0;
      const discount = (card.dataset.discount || '').trim();

      tiers[key] = { pct, qty, discount };
    });
    state.bundleTiers = tiers;
  }

  function setCurrentBundle(root, bundle) {
    const state = getState(root);
    state.bundle = bundle;
    curBundle = bundle;
  }

  function getCurrentBundle(root) {
    const bundle = getState(root).bundle;
    const tiers = getBundleTiers(root);
    return tiers[String(bundle)] ? bundle : curBundle;
  }

  function setCurrentShade(root, shade) {
    const state = getState(root);
    state.shade = shade;
    curShade = shade;
  }

  function getCurrentShade(root) {
    return getState(root).shade || '';
  }

  function isShadeAvailable(card) {
    return !card || card.dataset.variantAvailable === undefined || card.dataset.variantAvailable === 'true';
  }

  /** Keep `aria-pressed` in sync with `.selected` on shade toggle buttons (per root). */
  function syncShadeCardAriaPressed(scopedRoot) {
    normalizeRoot(scopedRoot).querySelectorAll('.shade-card').forEach((c) => {
      c.setAttribute('aria-pressed', c.classList.contains('selected') ? 'true' : 'false');
    });
  }

  /** Clear unavailable `.selected` shade only; never auto-pick a default on load. */
  function ensureAvailableShadeSelection(root) {
    const scopedRoot = normalizeRoot(root);
    const selected = scopedRoot.querySelector('.shade-card.selected');
    if (!selected) return null;
    if (isShadeAvailable(selected)) return selected;
    selected.classList.remove('selected');
    syncShadeCardAriaPressed(scopedRoot);
    return null;
  }

  function getStickyBarForRoot(root) {
    const scopedRoot = normalizeRoot(root);
    if (scopedRoot === document) return document.querySelector('.sticky-bar');

    const key = ensureRootKey(scopedRoot).dataset.lpCleanGlowRoot;
    const bars = document.querySelectorAll('.sticky-bar[data-lp-clean-glow-root]');
    for (const bar of bars) {
      if (bar.dataset.lpCleanGlowRoot === key) return bar;
    }
    return scopedRoot.querySelector('.sticky-bar');
  }

  function scopedQuery(root, selector) {
    const scopedRoot = normalizeRoot(root);
    const found = scopedRoot.querySelector(selector);
    if (found) return found;

    const sticky = getStickyBarForRoot(scopedRoot);
    return sticky && !scopedRoot.contains(sticky) ? sticky.querySelector(selector) : null;
  }

  function scopedQueryAll(root, selector) {
    const scopedRoot = normalizeRoot(root);
    if (scopedRoot === document) return Array.from(document.querySelectorAll(selector));

    const seen = new Set();
    const results = [];
    scopedRoot.querySelectorAll(selector).forEach((el) => {
      seen.add(el);
      results.push(el);
    });

    const sticky = getStickyBarForRoot(scopedRoot);
    if (sticky && !scopedRoot.contains(sticky)) {
      sticky.querySelectorAll(selector).forEach((el) => {
        if (seen.has(el)) return;
        seen.add(el);
        results.push(el);
      });
    }

    return results;
  }

  /** Timers for `.lp-sticky-variant-chip` dwell + post-fade cleanup (per chip element). */
  const stickyVariantChipTimers = new WeakMap();

  function prefersReducedMotion() {
    try {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (_e) {
      return false;
    }
  }

  function humanizeShadeToken(raw) {
    const s = String(raw || '')
      .trim()
      .replace(/[-_]+/g, ' ');
    if (!s) return '';
    return s.replace(/\b\w/g, function (ch) {
      return ch.toUpperCase();
    });
  }

  function getShadeShortLabel(card, fallbackShadeKey) {
    if (card) {
      const sn = card.querySelector('.shade-name');
      const fromName = sn && sn.textContent.trim();
      if (fromName) return fromName;
      const ds = (card.dataset.shade || '').trim();
      if (ds) return humanizeShadeToken(ds);
    }
    return humanizeShadeToken(fallbackShadeKey);
  }

  function isStickyBarInfoVariantChipHost(el) {
    if (!el || !el.parentElement) return false;
    const p = el.parentElement;
    return !!(p.classList && p.classList.contains('sticky-bar-info') && p.closest && p.closest('.sticky-bar'));
  }

  function isStickyBarVariantChipHost(el) {
    if (!el || !el.parentElement) return false;
    const p = el.parentElement;
    return !!(p.classList && p.classList.contains('sticky-atc-cluster') && p.closest && p.closest('.sticky-bar'));
  }

  function isAtcRowVariantChipHost(el) {
    if (!el || !el.parentElement) return false;
    const p = el.parentElement;
    return !!(p.classList && p.classList.contains('atc-row'));
  }

  function clearStickyVariantChipTimers(el) {
    const t = stickyVariantChipTimers.get(el);
    if (!t) return;
    if (t.dwell) clearTimeout(t.dwell);
    if (t.afterFade) clearTimeout(t.afterFade);
    t.dwell = null;
    t.afterFade = null;
  }

  /** Remove variant chips outside authorized hosts (info column, cluster, or atc-row fallback). */
  function removeLegacyMainRowStickyVariantChips(scopedRoot) {
    if (!scopedRoot || !scopedRoot.querySelectorAll) return;
    scopedRoot.querySelectorAll('.lp-sticky-variant-chip').forEach(function (el) {
      if (isStickyBarInfoVariantChipHost(el) || isStickyBarVariantChipHost(el) || isAtcRowVariantChipHost(el)) return;
      clearStickyVariantChipTimers(el);
      el.remove();
    });
  }

  function getAtcRowVariantChipHost(scopedRoot) {
    const mainAtc = scopedQuery(scopedRoot, '#main-atc');
    if (!mainAtc) return null;
    const row = mainAtc.closest('.atc-row');
    return row || mainAtc.parentElement;
  }

  function collectStickyVariantChipHosts(scopedRoot) {
    const hosts = [];
    const stickyBar = getStickyBarForRoot(scopedRoot);
    if (stickyBar) {
      const cluster = stickyBar.querySelector('.sticky-atc-cluster');
      if (cluster) hosts.push(cluster);
      else {
        const info = stickyBar.querySelector('.sticky-bar-info');
        if (info) hosts.push(info);
      }
    }
    if (!hosts.length) {
      const atcRow = getAtcRowVariantChipHost(scopedRoot);
      if (atcRow) hosts.push(atcRow);
    }
    return hosts;
  }

  function ensureStickyVariantChipElOnHost(host) {
    if (!host) return null;
    let el = host.querySelector(':scope > .lp-sticky-variant-chip');
    if (!el) {
      el = document.createElement('div');
      el.className = 'lp-sticky-variant-chip';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.setAttribute('aria-atomic', 'true');
      el.hidden = true;
      host.insertBefore(el, host.firstChild);
    }
    return el;
  }

  function hideStickyVariantChip(root) {
    const scopedRoot = normalizeRoot(root);
    removeLegacyMainRowStickyVariantChips(scopedRoot);
    collectStickyVariantChipHosts(scopedRoot).forEach(function (host) {
      const el = host.querySelector(':scope > .lp-sticky-variant-chip');
      if (!el) return;
      clearStickyVariantChipTimers(el);
      el.classList.remove('lp-sticky-variant-chip--visible');
      el.hidden = true;
      el.textContent = '';
    });
  }

  /** Brief confirmation pill above sticky ATC (`.sticky-atc-cluster`), with `.atc-row` fallback. */
  function showStickyVariantChip(root, text) {
    const scopedRoot = normalizeRoot(root);
    removeLegacyMainRowStickyVariantChips(scopedRoot);
    const label = String(text || '').trim();
    const hosts = collectStickyVariantChipHosts(scopedRoot);

    if (!label) {
      hideStickyVariantChip(scopedRoot);
      return;
    }

    hosts.forEach(function (host) {
      const el = ensureStickyVariantChipElOnHost(host);
      if (!el) return;

      let timers = stickyVariantChipTimers.get(el);
      if (!timers) {
        timers = { dwell: null, afterFade: null };
        stickyVariantChipTimers.set(el, timers);
      }
      clearStickyVariantChipTimers(el);

      el.classList.remove('lp-sticky-variant-chip--visible');
      void el.offsetWidth;

      el.textContent = label;
      el.removeAttribute('hidden');

      const goVisible = function () {
        el.classList.add('lp-sticky-variant-chip--visible');
      };

      if (prefersReducedMotion()) {
        goVisible();
      } else {
        requestAnimationFrame(function () {
          requestAnimationFrame(goVisible);
        });
      }

      const dwellMs = 4200;
      const fadeMs = prefersReducedMotion() ? 200 : 400;

      timers.dwell = setTimeout(function () {
        timers.dwell = null;
        el.classList.remove('lp-sticky-variant-chip--visible');
        timers.afterFade = setTimeout(function () {
          timers.afterFade = null;
          if (!el.classList.contains('lp-sticky-variant-chip--visible')) {
            el.hidden = true;
          }
        }, fadeMs);
      }, dwellMs);
    });
  }

  /** Shade + bundle tier line for chip (drawer-aligned copy) plus sell price when known. */
  function buildStickyVariantChipShadeBundleLabel(root) {
    const scopedRoot = normalizeRoot(root);
    const currentBundle = getCurrentBundle(scopedRoot);
    const b = getBundleData(currentBundle, scopedRoot);
    const shadeCard = getSelectedShadeCard(scopedRoot);
    const bundleCard = scopedRoot.querySelector(`.bundle-card[data-bundle="${currentBundle}"]`);
    const shadeNameEl = shadeCard && shadeCard.querySelector('.shade-name');
    const shadeName = shadeNameEl ? shadeNameEl.textContent.trim() : '';
    const bundleNameEl = bundleCard && bundleCard.querySelector('.bundle-name');
    const bundleName = bundleNameEl ? bundleNameEl.textContent.trim() : '';
    const qty = b && Number.isFinite(b.qty) ? b.qty : currentBundle;
    const bottleWord = qty === 1 ? 'bottle' : 'bottles';
    const tierParts = [];
    if (bundleName) tierParts.push(bundleName);
    if (qty) tierParts.push(`${qty} ${bottleWord}`);
    const tierLine = tierParts.join(' · ');
    let line = '';
    if (shadeName && tierLine) line = `${shadeName} · ${tierLine}`;
    else if (tierLine) line = tierLine;
    else line = shadeName || '';
    if (b && Number.isFinite(b.price)) {
      if (line) return `${line} — ${fmt(b.price)}`;
      return fmt(b.price);
    }
    return line;
  }

  function fmt(v) {
    return v % 1 === 0 ? `$${v}` : `$${v.toFixed(2)}`;
  }

  function fmtCents(cents) {
    return fmt(cents / 100);
  }

  function parseCents(value) {
    const cents = Number(value);
    return Number.isFinite(cents) && cents > 0 ? Math.round(cents) : null;
  }

  function parseMoneyText(value) {
    const match = String(value || '').replace(/,/g, '').match(/\d+(?:\.\d+)?/);
    if (!match) return null;
    const amount = Number(match[0]);
    return Number.isFinite(amount) ? amount : null;
  }

  function getSelectedShadeCard(root) {
    const scopedRoot = normalizeRoot(root);
    return ensureAvailableShadeSelection(scopedRoot);
  }

  function getSelectedVariantPricing(root) {
    const card = getSelectedShadeCard(root);
    if (!card) return null;
    if (!isShadeAvailable(card)) return null;

    const unitPriceCents = parseCents(card.dataset.variantPrice);
    if (unitPriceCents == null) return null;

    return { unitPriceCents };
  }

  function setVisibleText(el, text, visible) {
    if (!el) return;
    el.textContent = text || '';
    el.style.display = visible ? '' : 'none';
  }

  /** Restore primary ATC line from Liquid if a script path ever clears `.atc-btn__label`. */
  function syncMainAtcLabel(root) {
    const scopedRoot = normalizeRoot(root);
    const mainAtc = scopedQuery(scopedRoot, '#main-atc');
    if (!mainAtc) return;
    const lbl = mainAtc.querySelector('.atc-btn__label');
    if (!lbl) return;
    const fb = (mainAtc.getAttribute('data-atc-label') || '').trim();
    if (fb && !lbl.textContent.trim()) {
      lbl.textContent = fb;
    }
  }

  function syncBundleCardsFromSelectedVariant(root) {
    const scopedRoot = normalizeRoot(root);
    const pricing = getSelectedVariantPricing(scopedRoot);
    if (!pricing) return;

    scopedRoot.querySelectorAll('.bundle-card[data-bundle]').forEach((card) => {
      const bundleKey = String(card.dataset.bundle || '').trim();
      const base = getBundleTiers(scopedRoot)[bundleKey] || {};
      const qty = parseInt(card.dataset.qty || bundleKey, 10);
      const pctAttr = parseInt(card.dataset.pctDisplay, 10);
      const pct = Number.isFinite(pctAttr) && pctAttr >= 0 ? pctAttr : Number(base.pct || 0);

      if (!Number.isFinite(qty) || qty < 1 || !Number.isFinite(pct)) return;

      const subtotalCents = pricing.unitPriceCents * qty;
      const hasSavingsOffer = pct > 0;
      const priceCents = Math.round((subtotalCents * (100 - pct)) / 100);
      const originalCents = subtotalCents;
      const savingsCents = hasSavingsOffer ? Math.max(0, originalCents - priceCents) : 0;
      const perUnitCents = Math.round(priceCents / qty);

      card.dataset.unitPrice = String(pricing.unitPriceCents);
      delete card.dataset.compareUnitPrice;
      card.dataset.totalPrice = String(priceCents);
      if (originalCents > priceCents) {
        card.dataset.originalPrice = String(originalCents);
      } else {
        delete card.dataset.originalPrice;
      }
      if (savingsCents > 0) {
        card.dataset.savings = String(savingsCents);
      } else {
        delete card.dataset.savings;
      }

      const perEl = card.querySelector('.bundle-meta-per');
      if (perEl) perEl.textContent = `${fmtCents(perUnitCents)} / bottle`;

      setVisibleText(card.querySelector('.bp-pct'), pct > 0 ? `${pct}% OFF` : '', pct > 0);

      setVisibleText(card.querySelector('.bp-price'), fmtCents(priceCents), true);
      setVisibleText(card.querySelector('.bp-orig'), fmtCents(originalCents), originalCents > priceCents);
      setVisibleText(
        card.querySelector('.bp-save'),
        savingsCents > 0 ? `Save ${fmtCents(savingsCents)}` : '',
        savingsCents > 0
      );
    });
  }

  function syncBundleImagesFromSelectedVariant(root) {
    const scopedRoot = normalizeRoot(root);
    const shadeCard = getSelectedShadeCard(scopedRoot);
    const variantImage = shadeCard && (shadeCard.dataset.variantImage || '').trim();
    if (!variantImage) return;

    const alt = (shadeCard.dataset.variantImageAlt || '').trim();
    scopedRoot.querySelectorAll('.js-bundle-product-img, .bundle-card .bundle-imgs img').forEach((img) => {
      img.src = variantImage;
      if (img.hasAttribute('srcset')) img.removeAttribute('srcset');
      if (alt) img.alt = alt;
    });
  }

  /** Escape for safe innerHTML (discount codes are alphanumeric; still escape). */
  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /** Readable spacing for tier codes (e.g. 2for20 → 2 for 20) in sticky + trust UI */
  function humanizePromoCode(raw) {
    const s = String(raw || '').trim();
    if (!s) return '';
    let m = s.match(/^(\d+)\s*for\s*(\d+)$/i);
    if (m) return `${m[1]} for ${m[2]}`;
    m = s.match(/^(\d+)for(\d+)$/i);
    if (m) return `${m[1]} for ${m[2]}`;
    return s.replace(/(\d)([a-zA-Z])/g, '$1 $2').replace(/([a-zA-Z])(\d)/g, '$1 $2');
  }

  /** Trust block code note: HTML template with optional {code} and {shipping} tokens */
  function renderTrustCodeNotes(discount, price, root) {
    const scopedRoot = normalizeRoot(root);
    const code = (discount || '').trim();
    const total = typeof price === 'number' ? price : 0;
    const shippingNote = total >= 65 ? 'Free shipping with this order' : '';
    scopedRoot.querySelectorAll('script.bbe-trust-code-note-json').forEach((script) => {
      const p = script.nextElementSibling;
      if (!p || !p.classList.contains('js-trust-code-note-target')) return;
      try {
        const template = JSON.parse(script.textContent);
        let str = String(template);
        str = str.replace(
          /\{code\}/gi,
          '<span class="code-note__code">' + escapeHtml(humanizePromoCode(code)) + '</span>'
        );
        // {shipping} → "Free shipping with this order" if total ≥ $65, else remove the token + any surrounding separator
        if (shippingNote) {
          str = str.replace(/\{shipping\}/gi, shippingNote);
        } else {
          // Remove " · {shipping}" or "{shipping} · " or just "{shipping}"
          str = str.replace(/\s*[·•]\s*\{shipping\}/gi, '').replace(/\{shipping\}\s*[·•]\s*/gi, '').replace(/\{shipping\}/gi, '');
        }
        p.innerHTML = str;
      } catch (_e) {
        p.textContent = script.textContent || '';
      }
    });
  }

  function getBundleData(n, root) {
    const scopedRoot = normalizeRoot(root);
    const base = getBundleTiers(scopedRoot)[String(n)] || {};
    const card = scopedRoot.querySelector(`.bundle-card[data-bundle="${n}"]`);
    if (!card) return base;

    // Pull from data attributes (set by Liquid when product is selected)
    const qtyAttr = parseInt(card.dataset.qty, 10);
    const hasDiscountAttr = Object.prototype.hasOwnProperty.call(card.dataset, 'discount');
    const discountAttr = hasDiscountAttr ? (card.dataset.discount || '').trim() : null;
    const pctDisplay = parseInt(card.dataset.pctDisplay, 10);
    const qty = Number.isFinite(qtyAttr) && qtyAttr > 0 ? qtyAttr : base.qty;
    const pct = Number.isFinite(pctDisplay) && pctDisplay >= 0 ? pctDisplay : base.pct;
    const unitPriceCents = parseCents(card.dataset.unitPrice);
    let totalPriceCents = parseCents(card.dataset.totalPrice);
    let originalPriceCents = parseCents(card.dataset.originalPrice);
    let savingsCents = parseCents(card.dataset.savings);

    if (pct <= 0) {
      originalPriceCents = null;
      savingsCents = null;
    }

    if (totalPriceCents == null && unitPriceCents != null && Number.isFinite(qty) && Number.isFinite(pct)) {
      totalPriceCents = Math.round((unitPriceCents * qty * (100 - pct)) / 100);
    }

    if (pct > 0 && originalPriceCents == null && unitPriceCents != null && Number.isFinite(qty)) {
      originalPriceCents = unitPriceCents * qty;
    }

    if (
      pct > 0 &&
      savingsCents == null &&
      originalPriceCents != null &&
      totalPriceCents != null &&
      originalPriceCents > totalPriceCents
    ) {
      savingsCents = originalPriceCents - totalPriceCents;
    }

    const domPrice = parseMoneyText(card.querySelector('.bp-price')?.textContent);
    const domOrig = pct > 0 ? parseMoneyText(card.querySelector('.bp-orig')?.textContent) : null;
    const domSave = pct > 0 ? parseMoneyText(card.querySelector('.bp-save')?.textContent) : null;
    const price = totalPriceCents != null ? totalPriceCents / 100 : domPrice;
    // Strikethrough: current unit price × qty (pre–bundle-tier) — from data-original-price
    const orig =
      originalPriceCents != null && totalPriceCents != null && originalPriceCents > totalPriceCents
        ? originalPriceCents / 100
        : domOrig;
    let save = null;
    if (savingsCents != null && savingsCents > 0) {
      save = savingsCents / 100;
    } else if (orig != null && price != null && orig > price) {
      save = orig - price;
    } else if (domSave != null) {
      save = domSave;
    }

    return {
      price,
      orig,
      save,
      pct,
      qty,
      discount: discountAttr != null ? discountAttr : base.discount
    };
  }

  function getVariantId(shade, root) {
    const scopedRoot = normalizeRoot(root);
    const card = scopedRoot.querySelector(`.shade-card[data-shade="${shade}"]`);
    if (!card) return null;
    
    const id = (card.dataset.variantId || '').trim();
    const available = card.dataset.variantAvailable;
    
    // Check if variant ID is valid (numeric)
    if (!id || !/^\d+$/.test(id)) {
      console.warn(`Invalid variant ID for shade "${shade}": ${id}`);
      return null;
    }
    
    // Check if variant is available (if availability data exists)
    if (available !== undefined && available !== 'true') {
      console.warn(`Variant ${id} for shade "${shade}" is not available`);
      return null;
    }
    
    return id;
  }

  /** Two-step bundle + shade: native <details> accordions; bold summary = current choice. */
  function syncShadeEducationPanel(root) {
    const scopedRoot = normalizeRoot(root);
    const sel = getSelectedShadeCard(scopedRoot);
    const nameEl = scopedRoot.querySelector('.js-shade-edu-name');
    if (nameEl) {
      if (!sel) {
        nameEl.textContent = '';
      } else {
        const nm = sel.querySelector('.shade-name');
        nameEl.textContent = nm ? nm.textContent.trim() : '';
      }
    }
    scopedRoot.querySelectorAll('[data-shade-panel]').forEach((p) => {
      if (!sel) {
        p.hidden = true;
        return;
      }
      const key = String(sel.dataset.shade || '').trim();
      p.hidden = p.getAttribute('data-shade-panel') !== key;
    });
    syncShadeGuideGrid(scopedRoot);
  }

  function syncShadeGuideGrid(scopedRoot) {
    const root = normalizeRoot(scopedRoot);
    const guide = root.querySelector('.js-lp-shade-guide');
    if (!guide) return;
    const hasSelection = Boolean(getSelectedShadeCard(root));
    guide.classList.toggle('lp-shade-guide--hidden', hasSelection);
    guide.setAttribute('aria-hidden', hasSelection ? 'true' : 'false');
  }

  function syncBundleStepAccordion(fromBundleClick, root) {
    const scopedRoot = normalizeRoot(root);
    const d1 = scopedRoot.querySelector('#lp-bundle-details-1');
    const d2 = scopedRoot.querySelector('#lp-bundle-details-2');
    const d3 = scopedRoot.querySelector('#lp-bundle-details-3');
    if (!d1 || !d2) return;

    const el1 = scopedRoot.querySelector('.js-bundle-step1-choice');
    const card = scopedRoot.querySelector('.bundle-card.selected');
    if (el1 && card) {
      const nameEl = card.querySelector('.bundle-name');
      const pctEl = card.querySelector('.bp-pct');
      const parts = [];
      if (nameEl && nameEl.textContent.trim()) parts.push(nameEl.textContent.trim());
      if (pctEl && pctEl.textContent.trim()) parts.push(pctEl.textContent.trim());
      el1.textContent = parts.join(' · ') || '';
    }

    const el2 = scopedRoot.querySelector('.js-bundle-step2-choice');
    if (el2) {
      const shadeCard = getSelectedShadeCard(scopedRoot);
      const sn = shadeCard && shadeCard.querySelector('.shade-name');
      el2.textContent = sn ? sn.textContent.trim() : '';
    }

    const el3 = scopedRoot.querySelector('.js-bundle-step3-choice');
    if (el3) el3.textContent = '';

    if (fromBundleClick) {
      window.requestAnimationFrame(function () {
        // Keep step 1 open so all three bundle tiers stay visible and easy to change.
        d1.open = true;
        d2.open = true;
        if (d3) d3.open = false;
      });
    }
  }

  /** Step 1 complete: open Step 2 shade accordion (#lp-bundle-details-2) when present. */
  function openStep2AfterBundleSelect(root) {
    const scopedRoot = normalizeRoot(root);
    const d2 = scopedRoot.querySelector('#lp-bundle-details-2');
    if (!d2) return;

    window.requestAnimationFrame(function () {
      const d1 = scopedRoot.querySelector('#lp-bundle-details-1');
      const d3 = scopedRoot.querySelector('#lp-bundle-details-3');
      if (d1) d1.open = true;
      d2.open = true;
      if (d3) d3.open = false;
      updateBundleStepPill(scopedRoot);

      window.setTimeout(function () {
        scrollTo('lp-bundle-details-2', d2);
        const sm = d2.querySelector('summary');
        if (sm && typeof sm.focus === 'function') {
          try {
            sm.focus({ preventScroll: true });
          } catch (_err) {
            try {
              sm.focus();
            } catch (_err2) {
              /* ignore */
            }
          }
        }
      }, 80);
    });
  }

  /** Step 2 complete: open Step 3 upsells accordion (#lp-bundle-details-3) when present. */
  function openStep3AfterShadeSelect(root) {
    const scopedRoot = normalizeRoot(root);
    const d3 = scopedRoot.querySelector('#lp-bundle-details-3');
    if (!d3) return;

    window.requestAnimationFrame(function () {
      const d1 = scopedRoot.querySelector('#lp-bundle-details-1');
      const d2 = scopedRoot.querySelector('#lp-bundle-details-2');
      if (d1) d1.open = true;
      if (d2) d2.open = true;
      d3.open = true;
      updateBundleStepPill(scopedRoot);

      window.setTimeout(function () {
        scrollTo('lp-bundle-details-3', d3);
        const sm = d3.querySelector('summary');
        if (sm && typeof sm.focus === 'function') {
          try {
            sm.focus({ preventScroll: true });
          } catch (_err) {
            try {
              sm.focus();
            } catch (_err2) {
              /* ignore */
            }
          }
        }
      }, 80);
    });
  }

  function selectBundle(n, fromClick, root) {
    const scopedRoot = normalizeRoot(root);
    if (!getBundleTiers(scopedRoot)[String(n)]) {
      console.error(`Invalid bundle: ${n}`);
      return;
    }

    setCurrentBundle(scopedRoot, n);
    if (fromClick) {
      openStep2AfterBundleSelect(scopedRoot);
    }
    scopedRoot.querySelectorAll('.bundle-card').forEach(c => {
      c.classList.remove('selected');
      if (c.dataset.bundle === '2') c.classList.remove('lp-sheen-play');
    });
    const card = scopedRoot.querySelector(`.bundle-card[data-bundle="${n}"]`);
    if (card) card.classList.add('selected');

    if (n === 2) replayBundle2Sheen(scopedRoot);

    const b = getBundleData(n, scopedRoot);
    syncAtcPriceDisplay(scopedRoot, n);

    const sSub = scopedQuery(scopedRoot, '#s-sub');

    // Re-trigger border sheen on bundle switch
    const sheenWrap = scopedQuery(scopedRoot, '.atc-sheen-wrap');
    if (sheenWrap) {
      sheenWrap.style.animation = 'none';
      const before = sheenWrap;
      // Force reflow to restart ::before animation
      before.classList.remove('atc-sheen-active');
      void before.offsetWidth;
      before.classList.add('atc-sheen-active');
    }
    if (sSub) {
      const codePretty = humanizePromoCode(b.discount);
      if (b.discount && b.pct > 0) {
        sSub.innerHTML =
          `SAVE ${b.pct}% • CODE ` +
          `<span class="sticky-sub__code">${escapeHtml(String(codePretty).toUpperCase())}</span> • AUTO-APPLIED`;
      } else {
        const qty = b.qty || n;
        const bottleWord = qty === 1 ? 'bottle' : 'bottles';
        sSub.textContent = `${qty} ${bottleWord} selected`;
      }
    }

    const codeBannerCode = scopedQuery(scopedRoot, '#code-banner-code');
    if (codeBannerCode) codeBannerCode.textContent = b.discount;

    updateHeroCtaMaxSave(scopedRoot);
    syncMainAtcLabel(scopedRoot);
    syncBundleStepAccordion(!!fromClick, scopedRoot);
    syncShadeEducationPanel(scopedRoot);
    syncStickyAtcDrawer(scopedRoot);
    updateBundleStepPill(scopedRoot);

    if (fromClick) {
      showStickyVariantChip(scopedRoot, buildStickyVariantChipShadeBundleLabel(scopedRoot));
    }
  }

  function syncStickyAtcDrawer(root) {
    const scopedRoot = normalizeRoot(root);
    const detail = scopedQuery(scopedRoot, '#sticky-atc-detail');
    if (!detail) return;

    const currentBundle = getCurrentBundle(scopedRoot);
    const b = getBundleData(currentBundle, scopedRoot);
    const shadeCard = getSelectedShadeCard(scopedRoot);
    const bundleCard = scopedRoot.querySelector(`.bundle-card[data-bundle="${currentBundle}"]`);

    const shadeNameEl = shadeCard && shadeCard.querySelector('.shade-name');
    const shadeName = shadeNameEl ? shadeNameEl.textContent.trim() : '';
    const bundleNameEl = bundleCard && bundleCard.querySelector('.bundle-name');
    const bundleName = bundleNameEl ? bundleNameEl.textContent.trim() : '';
    const qty = b && Number.isFinite(b.qty) ? b.qty : currentBundle;
    const bottleWord = qty === 1 ? 'bottle' : 'bottles';

    const shadeEl = scopedQuery(scopedRoot, '#sticky-drawer-shade');
    if (shadeEl) shadeEl.textContent = shadeName ? `Shade: ${shadeName}` : '';

    const tierEl = scopedQuery(scopedRoot, '#sticky-drawer-tier');
    if (tierEl) {
      const tierParts = [];
      if (bundleName) tierParts.push(bundleName);
      if (qty) tierParts.push(`${qty} ${bottleWord}`);
      tierEl.textContent = tierParts.join(' · ');
    }

    setVisibleText(
      scopedQuery(scopedRoot, '#sticky-drawer-compare'),
      b && b.orig != null ? fmt(b.orig) : '',
      !!(b && b.orig != null)
    );
    setVisibleText(
      scopedQuery(scopedRoot, '#sticky-drawer-sell'),
      b && Number.isFinite(b.price) ? fmt(b.price) : '',
      !!(b && Number.isFinite(b.price))
    );
    setVisibleText(
      scopedQuery(scopedRoot, '#sticky-drawer-savings'),
      b && b.save != null ? `You save ${fmt(b.save)} today.` : '',
      !!(b && b.save != null)
    );

    const img = scopedQuery(scopedRoot, '#sticky-drawer-img');
    const shadeImage = shadeCard && (shadeCard.dataset.variantImage || '').trim();
    const shadeImageAlt = shadeCard && (shadeCard.dataset.variantImageAlt || '').trim();
    const srcImg = bundleCard && bundleCard.querySelector('img');
    if (img && shadeImage) {
      img.src = shadeImage;
      img.alt = shadeImageAlt || shadeName || '';
      img.hidden = false;
    } else if (img && srcImg && (srcImg.currentSrc || srcImg.src)) {
      img.src = srcImg.currentSrc || srcImg.src;
      img.alt = srcImg.alt || shadeName || '';
      img.hidden = false;
    } else if (img) {
      img.hidden = true;
    }
  }

  /** Max $ saved across the three bundle tiers (for “Save up to $X” in hero CTA). */
  function updateHeroCtaMaxSave(root) {
    const scopedRoot = normalizeRoot(root);
    let maxS = 0;
    for (let i = 1; i <= 3; i += 1) {
      const b = getBundleData(i, scopedRoot);
      if (b.save != null && b.save > maxS) maxS = b.save;
    }
    const chunk = maxS > 0 ? ` ${fmt(maxS)}` : '';
    scopedQueryAll(scopedRoot, '.js-hero-cta-max-save').forEach(function (el) {
      el.textContent = chunk;
    });
  }

  function quizWinnerFromTally(T) {
    const keys = ['light', 'medium', 'dark'];
    keys.sort(function (a, b) {
      if (T[b] !== T[a]) return T[b] - T[a];
      const pref = { medium: 0, light: 1, dark: 2 };
      return pref[a] - pref[b];
    });
    return keys[0];
  }

  /** Clamp quiz outcome to max tier when this SKU has no darker variant (e.g. STBL ceiling medium). */
  function clampQuizWinnerToCeiling(rawWinner, ceilingRaw) {
    const c = String(ceilingRaw || '')
      .trim()
      .toLowerCase();
    let w = String(rawWinner || '').trim().toLowerCase();
    if (!w) return 'medium';
    if (c === 'medium' && w === 'dark') return 'medium';
    if (c === 'light' && (w === 'dark' || w === 'medium')) return 'light';
    return w;
  }

  let lpShadeQuizDocOpenBound = false;
  function bindLpShadeQuizDocumentOpenOnce() {
    if (lpShadeQuizDocOpenBound) return;
    lpShadeQuizDocOpenBound = true;
    document.addEventListener(
      'click',
      function (e) {
        const opener = e.target.closest && e.target.closest('.js-shade-quiz-open');
        if (!opener) return;
        const mod = e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
        const fb = (opener.getAttribute('data-shade-quiz-fallback-url') || '').trim();
        const quizRoot = getSectionRoot(opener);
        const lbEl = scopedQuery(quizRoot, '#lp-shade-quiz-lb') || document.getElementById('lp-shade-quiz-lb');
        if (lbEl && typeof lbEl.__lpOpenShadeQuiz === 'function') {
          if (mod) {
            if (fb) {
              e.preventDefault();
              window.open(fb, '_blank', 'noopener,noreferrer');
            }
            return;
          }
          e.preventDefault();
          lbEl.__lpOpenShadeQuiz();
          return;
        }
        if (!mod && fb) {
          e.preventDefault();
          window.location.assign(fb);
        }
      },
      true
    );
  }

  function initShadeQuizLightboxForLb(lb) {
    if (!lb) return;
    if (lb.dataset.lpShadeQuizBound === '1') return;
    lb.dataset.lpShadeQuizBound = '1';

    const quizRoot = getSectionRoot(lb);
    const nextBtn = lb.querySelector('#lp-shade-quiz-lb-next');
    const backBtn = lb.querySelector('#lp-shade-quiz-lb-back');
    const closeX = lb.querySelector('#lp-shade-quiz-lb-x');
    const progFill = lb.querySelector('#lp-shade-quiz-lb-progress-fill');
    const progLabel = lb.querySelector('#lp-shade-quiz-lb-progress-label');
    const stepEls = lb.querySelectorAll('[data-lb-step]');

    let cfg = {};
    try {
      const el =
        (quizRoot && quizRoot.querySelector && quizRoot.querySelector('#lp-shade-quiz-config')) ||
        (lb.parentElement && lb.parentElement.querySelector('#lp-shade-quiz-config'));
      if (el && el.textContent) cfg = JSON.parse(el.textContent);
    } catch (_e) {
      cfg = {};
    }

    const fieldByStep = [null, 'sq_burn', 'sq_freckle', 'sq_tone', 'sq_eyes', 'sq_hair'];
    // Skip the intro slide on open: quiz now starts at question 1.
    const FIRST_STEP = 1;
    let step = FIRST_STEP;
    let lastFocus = null;
    /** True while clearing radios in reset — avoids `change` handlers auto-advancing. */
    let shadeQuizSuppressAutoAdvance = false;

    function applyResult() {
      const T = { light: 0, medium: 0, dark: 0 };
      ['sq_burn', 'sq_freckle', 'sq_tone', 'sq_eyes', 'sq_hair'].forEach(function (n) {
        const i = lb.querySelector('input[name="' + n + '"]:checked');
        if (i && T[i.value] !== undefined) T[i.value] += 1;
      });
      const winnerRaw = quizWinnerFromTally(T);
      const ceiling = String(cfg.quizShadeCeiling || '')
        .trim()
        .toLowerCase();
      const winner = clampQuizWinnerToCeiling(winnerRaw, ceiling);
      const pool = (cfg.variants || []).filter(function (x) {
        return x.tier === winner;
      });
      const v =
        pool.find(function (x) {
          return x.img;
        }) || pool[0];
      const res = cfg.results && cfg.results[winner];
      const schemaHero = res && res.hero_image;
      const heroUrl =
        (schemaHero && String(schemaHero).trim() !== '' && schemaHero) || (v && v.img) || '';
      const titleEl = lb.querySelector('#lp-shade-quiz-result-title');
      const img = lb.querySelector('#lp-shade-quiz-result-img');
      const imgWrap = lb.querySelector('#lp-shade-quiz-result-img-wrap');
      const copyEl = lb.querySelector('#lp-shade-quiz-result-copy');
      if (titleEl) titleEl.textContent = (v && v.title) || winner;
      if (img) {
        if (heroUrl) {
          img.src = heroUrl;
          img.alt = (v && v.title) || '';
          img.hidden = false;
          if (imgWrap) imgWrap.hidden = false;
        } else {
          img.removeAttribute('src');
          img.removeAttribute('srcset');
          img.hidden = true;
          if (imgWrap) imgWrap.hidden = true;
        }
      }
      if (copyEl) copyEl.innerHTML = (res && res.copy) || '';

      const ba = (cfg.ba && cfg.ba[winner]) || {};
      const bb = lb.querySelector('#lp-shade-quiz-ba-before');
      const baft = lb.querySelector('#lp-shade-quiz-ba-after');
      const baBox = lb.querySelector('#lp-shade-quiz-result-ba');
      if (bb) {
        if (ba.before) {
          bb.src = ba.before;
          bb.closest('figure').style.display = '';
        } else {
          bb.removeAttribute('src');
          bb.closest('figure').style.display = 'none';
        }
      }
      if (baft) {
        if (ba.after) {
          baft.src = ba.after;
          baft.closest('figure').style.display = '';
        } else {
          baft.removeAttribute('src');
          baft.closest('figure').style.display = 'none';
        }
      }
      if (baBox) {
        baBox.style.display = ba.before || ba.after ? 'grid' : 'none';
      }

      if (v && v.shade) {
        selectShade(v.shade, getSectionRoot(lb), true);
      }
    }

    function setProgress() {
      // Progress treats step 1..5 as the visible journey (intro is skipped).
      if (progFill) {
        let pct;
        if (step >= 1 && step <= 5) pct = Math.round((step / 6) * 100);
        else if (step === 6) pct = 100;
        else pct = 0;
        progFill.style.width = pct + '%';
      }
      if (!progLabel) return;
      if (step >= 1 && step <= 5) progLabel.textContent = 'Question ' + step + ' of 5';
      else if (step === 6) progLabel.textContent = 'Your match';
      else progLabel.textContent = '';
    }

    function setStep(n) {
      step = n;
      const sheet = lb.querySelector('.shade-quiz-lb__sheet');
      if (sheet) sheet.scrollTop = 0;
      const lbBody = lb.querySelector('.shade-quiz-lb__body');
      if (lbBody) lbBody.scrollTop = 0;
      stepEls.forEach(function (el) {
        const sn = parseInt(el.getAttribute('data-lb-step'), 10);
        const on = sn === step;
        el.classList.toggle('is-active', on);
        el.hidden = !on;
      });
      // Back is hidden on the first question (FIRST_STEP) and on the result.
      if (backBtn) backBtn.hidden = step <= FIRST_STEP || step === 6;
      if (nextBtn) {
        const finalLabel = (nextBtn.getAttribute('data-shade-quiz-label-final') || 'See my best match').trim() || 'See my best match';
        if (step >= 1 && step <= 4) nextBtn.textContent = 'Next';
        else if (step === 5) nextBtn.textContent = finalLabel;
        else if (step === 6) {
          const doneL = (nextBtn.getAttribute('data-shade-quiz-label-done') || 'SELECT THIS SHADE').trim();
          nextBtn.textContent = doneL || 'SELECT THIS SHADE';
        }
        else nextBtn.textContent = 'Continue';
      }
      setProgress();
      if (step === 6) {
        const resEl = lb.querySelector('[data-lb-step="6"]');
        if (resEl) resEl.focus();
      } else if (nextBtn) {
        nextBtn.focus();
      }
    }

    function resetQuiz() {
      shadeQuizSuppressAutoAdvance = true;
      lb.querySelectorAll('input[type="radio"]').forEach(function (r) {
        r.checked = false;
      });
      step = FIRST_STEP;
      setStep(FIRST_STEP);
      shadeQuizSuppressAutoAdvance = false;
    }

    function advanceAfterAnswerIfCurrent() {
      if (shadeQuizSuppressAutoAdvance || lb.hidden) return;
      if (step < FIRST_STEP || step > 5) return;
      if (!validateCurrent()) return;
      if (step === 5) {
        applyResult();
        setStep(6);
        return;
      }
      setStep(step + 1);
    }

    function openLb() {
      lastFocus = document.activeElement;
      lb.hidden = false;
      lb.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('lp-shade-quiz-lb-open');
      resetQuiz();
      if (nextBtn) nextBtn.focus();
    }
    lb.__lpOpenShadeQuiz = openLb;

    function closeLb() {
      lb.hidden = true;
      lb.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('lp-shade-quiz-lb-open');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    function validateCurrent() {
      if (step === 6) return true;
      const name = fieldByStep[step];
      if (!name) return true;
      return !!lb.querySelector('input[name="' + name + '"]:checked');
    }

    lb.querySelectorAll('[data-shade-quiz-lb-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        closeLb();
      });
    });
    if (closeX) closeX.addEventListener('click', closeLb);

    if (backBtn) {
      backBtn.addEventListener('click', function () {
        if (step > FIRST_STEP) setStep(step - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (step === 6) {
          closeLb();
          return;
        }
        if (!validateCurrent()) {
          nextBtn.classList.add('shade-quiz-lb__next--pulse');
          setTimeout(function () {
            nextBtn.classList.remove('shade-quiz-lb__next--pulse');
          }, 400);
          return;
        }
        if (step === 5) {
          applyResult();
          setStep(6);
          return;
        }
        setStep(step + 1);
      });
    }

    // Some browser/layout combinations do not reliably emit `change` when an
    // already-focused label is tapped. This click fallback guarantees
    // answer-tap -> next-question progression.
    lb.addEventListener('click', function (e) {
      const opt = e.target && e.target.closest ? e.target.closest('.shade-quiz-lb__opt') : null;
      if (!opt || !lb.contains(opt)) return;
      if (shadeQuizSuppressAutoAdvance) return;
      if (step < FIRST_STEP || step > 5) return;
      const expectedName = fieldByStep[step];
      if (!expectedName) return;
      const radio = opt.querySelector('input[type="radio"]');
      if (!radio || radio.name !== expectedName) return;

      if (!radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      advanceAfterAnswerIfCurrent();
    });

    lb.addEventListener('change', function (e) {
      const t = e.target;
      if (!t || t.type !== 'radio' || !lb.contains(t)) return;
      if (shadeQuizSuppressAutoAdvance) return;
      if (step < FIRST_STEP || step > 5) return;
      const expectedName = fieldByStep[step];
      if (!expectedName || t.name !== expectedName) return;
      advanceAfterAnswerIfCurrent();
    });

    const retryBtn = lb.querySelector('.js-shade-quiz-retry');
    if (retryBtn) {
      retryBtn.addEventListener('click', function () {
        resetQuiz();
        if (nextBtn) nextBtn.focus();
      });
    }

    /* Result CTA: Liquid has no `#lp-shade-quiz-lb-next`; primary action is
     * `.js-shade-quiz-select-shade`. Delegate on `#lp-shade-quiz-lb` so reparented
     * DOM still hits one code path. */
    lb.addEventListener('click', function (e) {
      const t = e.target;
      const sel = t && t.closest ? t.closest('.js-shade-quiz-select-shade') : null;
      if (!sel || !lb.contains(sel)) return;
      if (step !== 6) return;
      e.preventDefault();
      applyResult();
      closeLb();
    });

    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        closeLb();
      }
    });
  }

  function initShadeQuizLightbox() {
    bindLpShadeQuizDocumentOpenOnce();
    document.querySelectorAll('#lp-shade-quiz-lb').forEach(initShadeQuizLightboxForLb);
  }

  function initAnchorNav() {
    document.querySelectorAll('[data-lp-anchor-nav]').forEach((wrap) => {
      if (wrap.dataset.lpAnchorNavBound === '1') return;
      wrap.dataset.lpAnchorNavBound = '1';
      const onScroll = function () {
        const y = window.scrollY || 0;
        wrap.classList.toggle('lp-anchor-nav-outer--stuck', y > 72);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    });
    document.querySelectorAll('.lp-anchor-link').forEach(function (a) {
      if (a.dataset.lpAnchorLinkBound === '1') return;
      a.dataset.lpAnchorLinkBound = '1';
      a.addEventListener('click', function (e) {
        e.preventDefault();
        const t = a.getAttribute('data-lp-target') || a.getAttribute('href');
        if (!t) return;
        const id = t.replace('#', '');
        if (id) scrollTo(id, a);
      });
    });
  }

  function selectShade(s, root, fromUserClick) {
    const scopedRoot = normalizeRoot(root);
    const card = scopedRoot.querySelector(`.shade-card[data-shade="${s}"]`);
    if (!card) return;
    if (!isShadeAvailable(card)) {
      console.warn(`Variant for shade "${s}" is not available`);
      return;
    }

    const prevShade = getCurrentShade(scopedRoot);
    const shadeChanged = String(prevShade || '').trim() !== String(s || '').trim();

    setCurrentShade(scopedRoot, s);
    scopedRoot.querySelectorAll('.shade-card').forEach(c => c.classList.remove('selected'));
    if (card) card.classList.add('selected');
    syncShadeCardAriaPressed(scopedRoot);
    syncShadeEducationPanel(scopedRoot);
    syncBundleStepAccordion(false, scopedRoot);
    syncBundleCardsFromSelectedVariant(scopedRoot);
    syncBundleImagesFromSelectedVariant(scopedRoot);
    selectBundle(getCurrentBundle(scopedRoot), false, scopedRoot);
    showStickyVariantChip(scopedRoot, buildStickyVariantChipShadeBundleLabel(scopedRoot));
    if (fromUserClick && shadeChanged) {
      openStep3AfterShadeSelect(scopedRoot);
    }
  }


  const LP_ATC_OFFER_LABEL = 'CLAIM OFFER';

  function syncClaimOfferAtcCopy(scopedRoot, priceText) {
    const mainAtc = scopedQuery(scopedRoot, '#main-atc');
    if (mainAtc) {
      const lbl = mainAtc.querySelector('.atc-btn__label');
      if (lbl) lbl.textContent = LP_ATC_OFFER_LABEL;
      mainAtc.setAttribute('data-atc-label', LP_ATC_OFFER_LABEL);
      const atcPrice = scopedQuery(scopedRoot, '#atc-price');
      if (atcPrice) {
        atcPrice.textContent = priceText;
        atcPrice.style.display = priceText ? '' : 'none';
      }
    }
    const stickyAtc = scopedQuery(scopedRoot, '#sticky-atc');
    if (stickyAtc) {
      const labelSpan = stickyAtc.querySelector('span:not(.sticky-atc-price)');
      if (labelSpan) labelSpan.textContent = LP_ATC_OFFER_LABEL;
    }
    const stickyAtcPrice = scopedQuery(scopedRoot, '#sticky-atc-price');
    if (stickyAtcPrice) stickyAtcPrice.textContent = priceText;
  }

  function getStep3AddedAddonTotal(root) {
    const scopedRoot = normalizeRoot(root);
    let total = 0;
    scopedRoot.querySelectorAll('.lp-step3-card--added').forEach(function (card) {
      const btn = card.querySelector('.js-lp-step3-add');
      const cents = btn && parseCents(btn.getAttribute('data-variant-price'));
      if (cents != null) {
        total += cents / 100;
        return;
      }
      const priceEl = card.querySelector('.lp-step3-card__price');
      const amt = priceEl ? parseMoneyText(priceEl.textContent) : null;
      if (amt != null) total += amt;
    });
    return total;
  }

  function getAtcDisplayAmounts(bundleData, addonTotal) {
    const b = bundleData || {};
    const addon = Number.isFinite(addonTotal) && addonTotal > 0 ? addonTotal : 0;
    const basePrice = Number.isFinite(b.price) ? b.price : null;
    const price = basePrice != null ? basePrice + addon : null;
    const orig = b.orig != null ? b.orig + addon : null;
    let save = null;
    if (orig != null && price != null && orig > price) {
      save = orig - price;
    } else if (b.save != null) {
      save = b.save;
    }
    return { price, orig, save, pct: b.pct, qty: b.qty, discount: b.discount };
  }

  function syncAtcPriceDisplay(root, bundleKey) {
    const scopedRoot = normalizeRoot(root);
    const n = bundleKey != null ? bundleKey : getCurrentBundle(scopedRoot);
    const b = getBundleData(n, scopedRoot);
    const addonTotal = getStep3AddedAddonTotal(scopedRoot);
    const amounts = getAtcDisplayAmounts(b, addonTotal);

    const atcPrice = scopedQuery(scopedRoot, '#atc-price');
    const atcOrig = scopedQuery(scopedRoot, '#atc-orig');
    const atcSave = scopedQuery(scopedRoot, '#atc-save');
    const savingsAmt = scopedQuery(scopedRoot, '#savings-amt');
    const priceText = Number.isFinite(amounts.price) ? fmt(amounts.price) : '';

    if (atcPrice) atcPrice.textContent = priceText;
    syncClaimOfferAtcCopy(scopedRoot, priceText);
    if (atcOrig) {
      atcOrig.textContent = amounts.orig != null ? fmt(amounts.orig) : '';
      atcOrig.style.display = amounts.orig != null ? '' : 'none';
    }
    if (atcSave) {
      atcSave.textContent = amounts.save != null ? `Save ${fmt(amounts.save)}` : '';
      atcSave.style.display = amounts.save != null ? '' : 'none';
    }
    if (savingsAmt) {
      savingsAmt.textContent = amounts.save != null ? fmt(amounts.save) : '';
      if (savingsAmt.closest) {
        const wrap = savingsAmt.closest('.savings-banner');
        if (wrap) wrap.style.display = amounts.save != null ? '' : 'none';
      }
    }

    const sPrice = scopedQuery(scopedRoot, '#s-price');
    const sOrig = scopedQuery(scopedRoot, '#s-orig');
    if (sPrice) sPrice.textContent = priceText;
    if (sOrig) {
      sOrig.textContent = amounts.orig != null ? fmt(amounts.orig) : '';
      sOrig.style.display = amounts.orig != null ? '' : 'none';
    }

    const savingsText =
      amounts.save != null && amounts.save > 0 ? `You save ${fmt(amounts.save)} — ${amounts.pct}% off` : '';
    const savingsLine = scopedQuery(scopedRoot, '#atc-savings-line');
    if (savingsLine) {
      savingsLine.textContent = savingsText;
      savingsLine.classList.toggle('is-visible', savingsText.length > 0);
    }
    scopedQueryAll(scopedRoot, '.js-hero-cta-savings').forEach(function (el) {
      el.textContent = savingsText;
      el.classList.toggle('is-visible', savingsText.length > 0);
    });

    const atcPctNum = scopedQuery(scopedRoot, '#atc-pct-num');
    if (atcPctNum) atcPctNum.textContent = amounts.pct;

    const stickyBundleLabel = scopedQuery(scopedRoot, '#sticky-bundle-label');
    if (stickyBundleLabel) {
      const qty = amounts.qty || n;
      const bottleWord = qty === 1 ? 'BOTTLE' : 'BOTTLES';
      const saveStr =
        amounts.save != null && amounts.save > 0
          ? fmt(amounts.save) + ' OFF'
          : amounts.pct > 0
            ? amounts.pct + '% OFF'
            : '';
      stickyBundleLabel.textContent = saveStr ? `${qty} ${bottleWord} • ${saveStr}` : `${qty} ${bottleWord}`;
    }

    renderTrustCodeNotes(
      amounts.discount,
      Number.isFinite(amounts.price) ? amounts.price : 0,
      scopedRoot
    );
  }

  // ─── PRE-PURCHASE POPUP (Pre Upsell section) ───
  /** Prevent ajax-cart from opening drawer on LP silent adds. */
  const LP_AJAX_CART_SILENT_OPTS = { info: { should_keep_drawer_closed: true } };

  function getLpCheckoutUrl() {
    return document.querySelector('pre-upsell-modal')?.dataset.checkoutUrl || '/checkout';
  }

  function isLpPreUpsellEnabled(root) {
    const scopedRoot = normalizeRoot(root);
    const flag =
      scopedRoot === document
        ? document.querySelector('.lp-clean-glow .lp-clean-glow-pre-upsell-flag[data-enable-pre-upsell="true"]')
        : scopedRoot.querySelector('.lp-clean-glow-pre-upsell-flag[data-enable-pre-upsell="true"]');
    return Boolean(flag);
  }

  const LP_PRE_UPSELL_ADD_SELECTOR =
    '.pre-upsell__item:not(.added):not(.pre-upsell__item--market-hidden):not([hidden]) button[data-upsell-add]:not([disabled])';

  function resolveLpPreUpsellCheckout(modal) {
    if (typeof window.bbeResolvePreUpsellCheckout === 'function') {
      return window.bbeResolvePreUpsellCheckout(modal);
    }
    if (!(modal instanceof Element)) return Promise.resolve({ action: 'skip' });
    return Promise.resolve({
      action: modal.querySelector(LP_PRE_UPSELL_ADD_SELECTOR) ? 'open' : 'skip',
    });
  }

  function skipLpPreUpsellToCheckout(checkoutUrl) {
    if (typeof window.bbeSkipPreUpsellToCheckout === 'function') {
      window.bbeSkipPreUpsellToCheckout(checkoutUrl);
      return;
    }
    window.location.assign(checkoutUrl || '/checkout');
  }

  function openLpPreUpsellModal(modal, invoker) {
    if (!modal) return Promise.resolve(false);
    if (typeof modal.open === 'function') {
      modal.open(invoker || null);
      return Promise.resolve(true);
    }
    return customElements.whenDefined('pre-upsell-modal').then(() => {
      if (typeof modal.open === 'function') {
        modal.open(invoker || null);
        return true;
      }
      return false;
    });
  }

  function prepareLpCartForCheckout(cartLine) {
    const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
    const variantId = Number(cartLine.variantId);
    const qty = Number(cartLine.qty);
    const discount = (cartLine.discount || '').trim();

    // Do not clear cart — Step 3 add-ons may already be in cart via liquidAjaxCart.add.
    if (window.liquidAjaxCart && typeof window.liquidAjaxCart.add === 'function') {
      return new Promise((resolve, reject) => {
        window.liquidAjaxCart.add({ items: [{ id: variantId, quantity: qty }] }, Object.assign({}, LP_AJAX_CART_SILENT_OPTS, {
          lastCallback: (state) => {
            if (!state || !state.responseData || !state.responseData.ok) {
              reject(new Error('cart add failed'));
              return;
            }
            if (!discount || typeof window.liquidAjaxCart.update !== 'function') {
              resolve();
              return;
            }
            window.liquidAjaxCart.update({ discount }, {
              lastCallback: () => resolve(),
            });
          },
        }));
      });
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers,
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] }),
    })
      .then((res) => {
        if (!res.ok) throw new Error('cart add failed');
        return res.json();
      })
      .then((json) => {
        if (json && json.status) throw new Error(json.description || 'cart add failed');
        if (!discount) {
          if (window.liquidAjaxCart && typeof window.liquidAjaxCart.update === 'function') {
            return new Promise((resolve) => {
              window.liquidAjaxCart.update({}, { lastCallback: () => resolve() });
            });
          }
          return;
        }
        return fetch('/discount/' + encodeURIComponent(discount), { credentials: 'same-origin' })
          .catch(() => null)
          .then(() => {
            if (window.liquidAjaxCart && typeof window.liquidAjaxCart.update === 'function') {
              return new Promise((resolve) => {
                window.liquidAjaxCart.update({ discount }, { lastCallback: () => resolve() });
              });
            }
          });
      });
  }

  function runPreUpsellAtcFlow(root, cartLine, invoker) {
    const scopedRoot = normalizeRoot(root);
    const preUpsellModal = document.querySelector('pre-upsell-modal');

    return prepareLpCartForCheckout(cartLine)
      .then(() => {
        if (!preUpsellModal) throw new Error('pre-upsell unavailable');
        return resolveLpPreUpsellCheckout(preUpsellModal);
      })
      .then((outcome) => {
        if (!preUpsellModal) return;

        if (outcome && outcome.action === 'open') {
          return openLpPreUpsellModal(preUpsellModal, invoker).then((opened) => {
            if (!opened) throw new Error('pre-upsell open failed');
            atcNavPending = false;
            setAtcLoading(false, scopedRoot);
          });
        }

        skipLpPreUpsellToCheckout(preUpsellModal.dataset.checkoutUrl || getLpCheckoutUrl());
      })
      .catch((err) => {
        console.warn('[BBE lp-clean-glow] pre-upsell ATC failed; routing to checkout', err);
        atcNavPending = false;
        setAtcLoading(false, scopedRoot);
        skipLpPreUpsellToCheckout(getLpCheckoutUrl());
      });
  }

  // ─── SHOPIFY CART INTEGRATION ───
  // Navigates to /cart/VARIANT:QTY?discount=CODE so Shopify applies the
  // quantity-tier discount at checkout without needing the customer to paste it.
  function buildShopifyCartURL(root) {
    const scopedRoot = normalizeRoot(root);
    const currentBundle = getCurrentBundle(scopedRoot);
    const currentShade = getCurrentShade(scopedRoot);
    const bundle = getBundleData(currentBundle, scopedRoot);
    const variantId = getVariantId(currentShade, scopedRoot);

    if (!bundle || !Number.isFinite(bundle.qty) || bundle.qty < 1) {
      console.error(`Invalid bundle qty: ${currentBundle}`);
      return null;
    }
    if (!variantId) {
      console.error(`Missing variant ID for shade: ${currentShade}. Set it in the theme editor (Bundle picker block → Cart wiring).`);
      return null;
    }

    const qs = bundle.discount ? `?discount=${encodeURIComponent(bundle.discount)}` : '';
    return `/cart/${variantId}:${bundle.qty}${qs}`;
  }

  /** True while a cart URL navigation is in progress (avoids double-submit). */
  let atcNavPending = false;

  /**
   * Main + sticky checkout buttons: lock UI and show spinner while the browser
   * navigates to the cart (next paint may be delayed on slow connections).
   */
  function setAtcLoading(loading, root) {
    const buttons = root ? scopedQueryAll(root, '#main-atc, #sticky-atc') : Array.from(document.querySelectorAll('#main-atc, #sticky-atc'));
    buttons.forEach((btn) => {
      if (!btn) return;
      btn.classList.toggle('is-loading', loading);
      if (loading) {
        btn.setAttribute('disabled', '');
        btn.setAttribute('aria-busy', 'true');
      } else {
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-busy');
      }
    });
  }

  function addToCart(source) {
    if (atcNavPending) return;
    const invoker =
      source && source.currentTarget
        ? source.currentTarget
        : source && source.nodeType === 1
          ? source
          : null;
    const scopedRoot = invoker ? getSectionRoot(invoker) : normalizeRoot(source);
    const currentBundle = getCurrentBundle(scopedRoot);
    const currentShade = getCurrentShade(scopedRoot);
    const bundle = getBundleData(currentBundle, scopedRoot);
    const variantId = getVariantId(currentShade, scopedRoot);

    if (!bundle || !Number.isFinite(bundle.qty) || bundle.qty < 1) {
      console.error(`Invalid bundle qty: ${currentBundle}`);
      alert('Please select a shade and ensure the product is properly configured. If the issue persists, contact support.');
      return;
    }
    if (!variantId) {
      console.error(`Missing variant ID for shade: ${currentShade}. Set it in the theme editor (Bundle picker block → Cart wiring).`);
      alert('Please select a shade and ensure the product is properly configured. If the issue persists, contact support.');
      return;
    }

    const preUpsellModal = document.querySelector('pre-upsell-modal');
    if (isLpPreUpsellEnabled(scopedRoot) && preUpsellModal) {
      atcNavPending = true;
      setAtcLoading(true, scopedRoot);
      runPreUpsellAtcFlow(scopedRoot, {
        variantId,
        qty: bundle.qty,
        discount: bundle.discount || '',
      }, invoker);
      return;
    }

    atcNavPending = true;
    setAtcLoading(true, scopedRoot);

    var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
    var addBody = JSON.stringify({ items: [{ id: Number(variantId), quantity: bundle.qty }] });
    var discountCode = (bundle.discount || '').trim();

    var doAdd;
    if (window.liquidAjaxCart && typeof window.liquidAjaxCart.add === 'function') {
      doAdd = new Promise(function (resolve, reject) {
        window.liquidAjaxCart.add({ items: [{ id: Number(variantId), quantity: bundle.qty }] }, Object.assign({}, LP_AJAX_CART_SILENT_OPTS, {
          lastCallback: function (state) {
            if (!state || !state.responseData || !state.responseData.ok) {
              reject(new Error('cart add failed'));
              return;
            }
            resolve();
          }
        }));
      });
    } else {
      doAdd = fetch(getCartAddJsURL(), {
        method: 'POST', headers: headers, credentials: 'same-origin', body: addBody
      }).then(function (res) {
        if (!res.ok) throw new Error('cart add failed');
        return res.json();
      });
    }

    doAdd
      .then(function () {
        if (!discountCode) return;
        return fetch('/discount/' + encodeURIComponent(discountCode), { credentials: 'same-origin' }).catch(function () {});
      })
      .then(function () {
        window.location.assign('/checkout');
      })
      .catch(function () {
        atcNavPending = false;
        setAtcLoading(false, scopedRoot);
        window.location.assign(getLpCheckoutUrl());
      });
  }

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      atcNavPending = false;
      setAtcLoading(false);
    }
  });

  // ─── SCROLL HELPERS ───
  function getScrollSource(source) {
    if (source && source.currentTarget) return source.currentTarget;
    if (source && source.nodeType === 1) return source;
    if (window.event) return window.event.currentTarget || window.event.target || null;
    return document.activeElement && document.activeElement !== document.body ? document.activeElement : null;
  }

  function resolveScrollTarget(id, source) {
    const cleanId = String(id || '').replace(/^#/, '').trim();
    if (!cleanId) return null;

    const scrollSource = getScrollSource(source);
    if (scrollSource && scrollSource.closest) {
      const scopedRoot = getSectionRoot(scrollSource);
      if (scopedRoot && scopedRoot !== document) {
        const scopedTarget = findByIdWithin(scopedRoot, cleanId);
        if (scopedTarget) return scopedTarget;
      }
    }

    if (activeCleanGlowRoot && activeCleanGlowRoot !== document && document.contains(activeCleanGlowRoot)) {
      const activeTarget = findByIdWithin(activeCleanGlowRoot, cleanId);
      if (activeTarget) return activeTarget;
    }

    return document.getElementById(cleanId);
  }

  function scrollTo(id, source) {
    const cleanId = String(id || '').replace(/^#/, '').trim();
    if (!cleanId) return;
    const el = resolveScrollTarget(cleanId, source);
    if (!el) {
      console.warn(`Element with id "${cleanId}" not found`);
      return;
    }
    const raw = getComputedStyle(document.documentElement).getPropertyValue('--lp-scroll-anchor-offset').trim();
    const offset = parseFloat(raw) || 112;
    const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scroll({ top, behavior: 'smooth' });
  }

  // ─── COUNTDOWN TIMER ───
  function initCountdown() {
    const KEY = 'bbe_clean_glow_end_v2';
    const DURATION = (5 * 3600 + 8 * 60 + 12) * 1000; // 5:08:12
    
    let end = +localStorage.getItem(KEY);
    if (!end || end < Date.now()) {
      end = Date.now() + DURATION;
      localStorage.setItem(KEY, end);
    }

    // Each section uses a unique `id="timer-{{ section.id }}"` (valid HTML when multiple LPs
    // load). Bind every countdown span under `.lp-clean-glow` sections.
    document.querySelectorAll('.shopify-section.lp-clean-glow .ann-timer').forEach((el) => {
      if (el.dataset.lpCountdownBound === '1') return;
      el.dataset.lpCountdownBound = '1';

      function tick() {
        const left = Math.max(0, end - Date.now());
        const h = String(Math.floor(left / 3600000)).padStart(2, '0');
        const m = String(Math.floor(left % 3600000 / 60000)).padStart(2, '0');
        const s = String(Math.floor(left % 60000 / 1000)).padStart(2, '0');
        el.textContent = `${h}:${m}:${s}`;
        if (left > 0) setTimeout(tick, 1000);
      }
      tick();
    });
  }

  // ─── BEFORE / AFTER SLIDER (scoped per [data-ba-wrap]; supports theme editor / multiple instances) ───
  function initBeforeAfterForWrap(wrap) {
    if (wrap.dataset.lpBeforeAfterBound === '1') return;
    const clip = wrap.querySelector('[data-ba-clip]');
    const line = wrap.querySelector('[data-ba-line]');
    const knob = wrap.querySelector('[data-ba-knob]');
    const img = wrap.querySelector('[data-ba-after-img]');

    if (!clip || !line || !knob) {
      console.warn('BA slider: missing clip, line, or knob');
      return;
    }
    if (!img) {
      console.warn('BA slider: missing after image');
      return;
    }
    wrap.dataset.lpBeforeAfterBound = '1';

    let pct = 50;

    function updateImageWidth() {
      const w = wrap.offsetWidth;
      if (w > 0) img.style.width = w + 'px';
    }

    function setPct(p) {
      pct = Math.max(3, Math.min(97, p));
      clip.style.left = pct + '%';
      clip.style.right = '0';
      clip.style.width = 'auto';
      line.style.left = pct + '%';
      knob.style.left = pct + '%';
    }

    let dragging = false;
    let activeTouchId = null;
    let touchArmed = false;
    let touchStartX = 0;
    let touchStartY = 0;

    function clientXFrom(e) {
      if (e.touches && e.touches.length) return e.touches[0].clientX;
      if (e.changedTouches && e.changedTouches.length) return e.changedTouches[0].clientX;
      return e.clientX;
    }

    function clientYFrom(e) {
      if (e.touches && e.touches.length) return e.touches[0].clientY;
      if (e.changedTouches && e.changedTouches.length) return e.changedTouches[0].clientY;
      return e.clientY;
    }

    function findTrackedTouch(e) {
      if (activeTouchId == null) return null;
      if (e.touches) {
        for (let i = 0; i < e.touches.length; i++) {
          if (e.touches[i].identifier === activeTouchId) return e.touches[i];
        }
      }
      return null;
    }

    function getClientX(e) {
      const tr = findTrackedTouch(e);
      if (tr) return tr.clientX;
      return e.touches && e.touches.length ? e.touches[0].clientX : e.clientX;
    }

    function fromEvent(e) {
      const r = wrap.getBoundingClientRect();
      if (r.width <= 0) return;
      setPct(((getClientX(e) - r.left) / r.width) * 100);
    }

    function handleMove(e) {
      if (dragging) {
        e.preventDefault();
        fromEvent(e);
      }
    }

    function onTouchMoveSlider(e) {
      let tch = findTrackedTouch(e);
      if (!tch && e.changedTouches && activeTouchId != null) {
        for (let i = 0; i < e.changedTouches.length; i++) {
          if (e.changedTouches[i].identifier === activeTouchId) {
            tch = e.changedTouches[i];
            break;
          }
        }
      }
      if (activeTouchId == null) return;
      if (!tch && !dragging) return;
      const x = tch ? tch.clientX : clientXFrom(e);
      const y = tch ? tch.clientY : clientYFrom(e);
      if (!dragging) {
        if (!touchArmed) return;
        const dx = Math.abs(x - touchStartX);
        const dy = Math.abs(y - touchStartY);
        if (dy > 14 && dy > dx * 1.12) {
          touchArmed = false;
          activeTouchId = null;
          return;
        }
        if (dx > 14 && dx > dy * 1.05) {
          dragging = true;
        } else {
          return;
        }
      }
      e.preventDefault();
      fromEvent(e);
    }

    function onTouchEndSlider(e) {
      if (activeTouchId == null) return;
      const still = e.touches && [...e.touches].some((t) => t.identifier === activeTouchId);
      if (!still) {
        activeTouchId = null;
        touchArmed = false;
        dragging = false;
      }
    }

    function scheduleSync() {
      requestAnimationFrame(() => {
        updateImageWidth();
        setPct(pct);
      });
    }

    wrap.addEventListener('mousedown', (e) => {
      dragging = true;
      fromEvent(e);
    });
    wrap.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1) return;
      activeTouchId = e.touches[0].identifier;
      touchArmed = true;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      dragging = false;
    }, { passive: true });
    wrap.addEventListener('touchmove', onTouchMoveSlider, { passive: false });
    document.addEventListener('mousemove', handleMove);
    document.addEventListener('mouseup', () => {
      dragging = false;
    });
    wrap.addEventListener('touchend', onTouchEndSlider);
    document.addEventListener('touchend', onTouchEndSlider, { passive: true });
    document.addEventListener('touchcancel', onTouchEndSlider, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(() => {
        updateImageWidth();
        setPct(pct);
      });
      ro.observe(wrap);
    }
    window.addEventListener('resize', updateImageWidth);

    img.addEventListener('load', scheduleSync, { once: true });
    window.addEventListener('load', scheduleSync, { once: true });
    if (img.complete && img.naturalWidth > 0) scheduleSync();

    // Fallback: schedule a delayed sync in case images load weirdly
    setTimeout(scheduleSync, 500);
    setTimeout(scheduleSync, 1500);
  }

  function initBeforeAfter() {
    document.querySelectorAll('[data-ba-wrap]').forEach(initBeforeAfterForWrap);
  }

  function replayBundle2Sheen(root) {
    const scopedRoot = normalizeRoot(root);
    const card2 = scopedRoot.querySelector('.bundle-card[data-bundle="2"]');
    if (!card2 || !card2.classList.contains('selected')) return;
    card2.classList.remove('lp-sheen-play');
    // reflow so animation can restart when re-selecting tier 2
    void card2.offsetWidth;
    card2.classList.add('lp-sheen-play');
  }

  // ─── FAQ ACCORDION ───
  function toggleFaq(item) {
    const body = item.querySelector('.faq-body');
    if (!body) return;

    if (item.classList.contains('open')) {
      item.classList.remove('open');
      body.style.maxHeight = '0';
    } else {
      item.classList.add('open');
      body.style.maxHeight = body.scrollHeight + 40 + 'px';
    }
  }

  function initFAQ() {
    document.querySelectorAll('.faq-item').forEach(item => {
      const body = item.querySelector('.faq-body');
      if (body && item.classList.contains('open')) {
        body.style.maxHeight = body.scrollHeight + 40 + 'px';
      }
    });
  }

  // ─── REVIEW FILTERS ───
  function filterRevs(type, chip) {
    if (!chip) return;
    const scopedRoot = getSectionRoot(chip);
    scopedRoot.querySelectorAll('.chip').forEach(c => c.classList.remove('active'));
    chip.classList.add('active');
    scopedRoot.querySelectorAll('.review-card').forEach(card => {
      const isMatch = type === 'all' || card.dataset.skin === type;
      card.classList.toggle('hidden', !isMatch);
      card.style.display = isMatch ? '' : 'none';
    });
  }

  // ─── BOTTOM STICKY BAR: reparent to <body> ───
  // `position:fixed` is often broken when any ancestor (e.g. .shopify-section) has
  // transform/filter/perspective — the bar then sticks to the section, not the viewport,
  // so it only appears at the end of the page. Moving to body restores viewport anchoring.
  function teardownStickySummaryToggle(rootOrKey) {
    const key =
      typeof rootOrKey === 'string'
        ? rootOrKey
        : rootOrKey && rootOrKey.dataset
          ? rootOrKey.dataset.lpCleanGlowRoot
          : '';
    if (!key) return;

    const state = stickySummaryState.get(key);
    if (!state) return;

    if (state.toggle && state.onClick) state.toggle.removeEventListener('click', state.onClick);
    if (state.onKeydown) document.removeEventListener('keydown', state.onKeydown);
    if (state.toggle && state.toggle.dataset) delete state.toggle.dataset.lpStickySummaryBound;
    stickySummaryState.delete(key);
  }

  function removeReparentedStickyForRoot(root) {
    if (!root || !root.dataset) return;
    const key = root.dataset.lpCleanGlowRoot;
    if (!key) return;
    teardownStickySummaryToggle(key);
    document.querySelectorAll('.sticky-bar[data-lp-clean-glow-root]').forEach((bar) => {
      if (bar.dataset.lpCleanGlowRoot !== key || root.contains(bar)) return;
      bar.remove();
    });
  }

  function cleanupOrphanedStickyBars() {
    document.querySelectorAll('.sticky-bar[data-lp-reparented-to-body="1"][data-lp-clean-glow-root]').forEach((bar) => {
      const key = bar.dataset.lpCleanGlowRoot;
      if (!key || !getRootByKey(key)) {
        teardownStickySummaryToggle(key);
        bar.remove();
      }
    });
  }

  function reparentBottomStickyToBody() {
    cleanupOrphanedStickyBars();
    const roots = getSectionRoots();
    if (!roots.length) return;
    document.documentElement.classList.add('lp-has-clean-glow');
    roots.forEach((section) => {
      const keyedRoot = ensureRootKey(section);
      const bar = section.querySelector('.sticky-bar');
      if (!bar || bar.dataset.lpReparentedToBody === '1') return;
      bar.dataset.lpCleanGlowRoot = keyedRoot.dataset.lpCleanGlowRoot || '';
      document.body.appendChild(bar);
      bar.dataset.lpReparentedToBody = '1';
    });
  }

  function initStickySummaryToggle(root) {
    const scopedRoot = normalizeRoot(root);
    const key = scopedRoot !== document ? ensureRootKey(scopedRoot).dataset.lpCleanGlowRoot : 'document';
    const toggle = scopedQuery(scopedRoot, '#sticky-summary-toggle');
    const detail = scopedQuery(scopedRoot, '#sticky-atc-detail');
    if (!toggle || !detail) return;
    if (toggle.dataset.lpStickySummaryBound === '1') return;
    toggle.dataset.lpStickySummaryBound = '1';

    const setOpen = (open) => {
      toggle.setAttribute('aria-expanded', String(open));
      detail.hidden = !open;
      if (open) syncStickyAtcDrawer(scopedRoot);
    };

    setOpen(toggle.getAttribute('aria-expanded') === 'true' && !detail.hidden);
    const onClick = () => {
      setOpen(detail.hidden);
    };
    const onKeydown = (e) => {
      if (e.key === 'Escape' && !detail.hidden) setOpen(false);
    };

    toggle.addEventListener('click', onClick);
    document.addEventListener('keydown', onKeydown);
    stickySummaryState.set(key, { toggle, onClick, onKeydown });
  }

  function teardownHeaderVisibilityAfterPressBar() {
    if (!headerVisibilityState) return;
    window.removeEventListener('scroll', headerVisibilityState.requestUpdate);
    window.removeEventListener('resize', headerVisibilityState.requestUpdate);
    headerVisibilityState = null;
  }

  function initHeaderVisibilityAfterPressBar() {
    const root = document.documentElement;
    const trigger =
      document.querySelector('.press-bar-outer') ||
      document.querySelector('.press-bar') ||
      document.getElementById('bundle');
    const masthead = document.querySelector('.lp-cg-masthead');
    if (headerVisibilityState && (!document.contains(headerVisibilityState.trigger) || !document.contains(headerVisibilityState.masthead))) {
      teardownHeaderVisibilityAfterPressBar();
    }
    if (!trigger || !masthead) return;
    if (headerVisibilityState && headerVisibilityState.trigger === trigger && headerVisibilityState.masthead === masthead) return;
    teardownHeaderVisibilityAfterPressBar();

    let ticking = false;
    const update = () => {
      ticking = false;
      const annBar = document.querySelector('.ann-bar');
      const annH = annBar ? annBar.getBoundingClientRect().height : 0;
      const triggerBottom = trigger.getBoundingClientRect().bottom;
      root.classList.toggle('lp-buybox-passed', triggerBottom <= annH + 8);
    };
    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    headerVisibilityState = { trigger, masthead, requestUpdate };
  }

  // ─── CODE BANNER — click anywhere to copy + visible "Copied!" feedback ───
  function initCodeBannerCopy() {
    document.querySelectorAll('.code-banner .code-pill-wrap').forEach((wrap) => {
      if (wrap.dataset.lpCodeBannerBound === '1') return;
      const codeEl = wrap.querySelector('#code-banner-code, .code-chip');
      if (!codeEl) return;
      wrap.dataset.lpCodeBannerBound = '1';

      // Make the whole pill behave like a real button for keyboard + a11y.
      if (!wrap.hasAttribute('role')) wrap.setAttribute('role', 'button');
      if (!wrap.hasAttribute('tabindex')) wrap.setAttribute('tabindex', '0');
      wrap.setAttribute(
        'aria-label',
        'Copy promo code ' + (codeEl.textContent || '').trim()
      );

      let resetTimer;
      const flash = () => {
        wrap.classList.remove('is-copied');
        // Force reflow so the animation restarts on rapid taps.
        void wrap.offsetWidth;
        wrap.classList.add('is-copied');
        clearTimeout(resetTimer);
        resetTimer = setTimeout(() => wrap.classList.remove('is-copied'), 1700);
      };

      const fallbackCopy = (text) => {
        try {
          const ta = document.createElement('textarea');
          ta.value = text;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          ta.style.pointerEvents = 'none';
          document.body.appendChild(ta);
          ta.focus();
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
          return true;
        } catch (_e) {
          return false;
        }
      };

      const doCopy = (e) => {
        const text = (codeEl.textContent || '').trim();
        if (!text) return;
        if (e && typeof e.preventDefault === 'function') e.preventDefault();
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(flash, () => {
            if (fallbackCopy(text)) flash();
          });
        } else if (fallbackCopy(text)) {
          flash();
        }
      };

      wrap.addEventListener('click', doCopy);
      wrap.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') doCopy(e);
      });
    });
  }

  function getCartAddJsURL() {
    const r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    const base = typeof r === 'string' && r.length ? r : '/';
    return base.endsWith('/') ? base + 'cart/add.js' : base + '/cart/add.js';
  }

  function announceStep3(root, msg) {
    const scopedRoot = normalizeRoot(root);
    const el = scopedRoot.querySelector('[data-lp-step3-announcer]');
    if (!el || !msg) return;
    el.textContent = '';
    window.requestAnimationFrame(function () {
      el.textContent = String(msg);
    });
  }

  function showStep3Toast(root, msg) {
    const scopedRoot = normalizeRoot(root);
    const t = scopedRoot.querySelector('[data-lp-step3-toast]');
    if (!t || !msg) return;
    t.textContent = String(msg);
    t.hidden = false;
    clearTimeout(t.__lpStep3ToastTimer);
    t.__lpStep3ToastTimer = setTimeout(function () {
      t.hidden = true;
      t.textContent = '';
    }, 5200);
  }

  function updateBundleStepPill(root) {
    const scopedRoot = normalizeRoot(root);
    const pill = scopedRoot.querySelector('.lp-step-pill--3up');
    if (!pill) return;
    const d1 = scopedRoot.querySelector('#lp-bundle-details-1');
    const d2 = scopedRoot.querySelector('#lp-bundle-details-2');
    const d3 = scopedRoot.querySelector('#lp-bundle-details-3');
    const nums = pill.querySelectorAll('[data-lp-step-pill-num]');
    nums.forEach(function (n) {
      n.classList.remove('lp-step-pill__n--on');
    });
    let step = 1;
    if (d3 && d3.open) step = 3;
    else if (d2 && d2.open) step = 2;
    else if (d1 && d1.open) step = 1;
    const active = pill.querySelector('[data-lp-step-pill-num="' + step + '"]');
    if (active) active.classList.add('lp-step-pill__n--on');
  }

  function initBundleDetailsStepPillSync(root) {
    const scopedRoot = normalizeRoot(root);
    if (scopedRoot === document) return;
    if (scopedRoot.dataset.lpDetailsToggleBound === '1') return;
    scopedRoot.dataset.lpDetailsToggleBound = '1';
    scopedRoot.querySelectorAll('.bundle-step-details').forEach(function (det) {
      det.addEventListener('toggle', function () {
        updateBundleStepPill(scopedRoot);
      });
    });
    updateBundleStepPill(scopedRoot);
  }

  function initStepThreeUpsell(root) {
    bindLpStep3AddDocumentOnce();
  }

  let lpStep3AddDocBound = false;

  function updateBundleStep3Choice(root, label) {
    const scopedRoot = normalizeRoot(root);
    const el3 = scopedRoot.querySelector('.js-bundle-step3-choice');
    if (el3 && label) el3.textContent = String(label);
  }

  function handleStep3AddClick(btn, e) {
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    if (e && typeof e.preventDefault === 'function') e.preventDefault();

    const scopedRoot = getSectionRoot(btn);
    const card = btn.closest('[data-lp-step3-card]');
    const vidRaw = (btn.getAttribute('data-variant-id') || btn.dataset.variantId || '').trim();
    if (!vidRaw || !/^\d+$/.test(vidRaw)) return;

    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const originalLabel = btn.textContent;
    btn.setAttribute('aria-busy', 'true');
    btn.setAttribute('disabled', '');
    btn.classList.add('is-loading');

    var addPromise;
    if (window.liquidAjaxCart && typeof window.liquidAjaxCart.add === 'function') {
      addPromise = new Promise(function (resolve, reject) {
        window.liquidAjaxCart.add({ items: [{ id: Number(vidRaw), quantity: 1 }] }, {
          lastCallback: function (state) {
            if (!state || !state.responseData || !state.responseData.ok) {
              var errBody = state && state.responseData && state.responseData.body;
              var errMsg = (errBody && (errBody.description || errBody.message)) || 'Could not add to cart.';
              reject(new Error(errMsg));
              return;
            }
            resolve();
          }
        });
      });
    } else {
      addPromise = fetch(getCartAddJsURL(), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(vidRaw), quantity: 1 }] })
      }).then(function (res) {
        return res.text().then(function (text) {
          var body = {};
          if (text) { try { body = JSON.parse(text); } catch (_err) { body = {}; } }
          if (!res.ok) {
            var errMsg = (body && (body.description || body.message)) || text || 'Could not add to cart.';
            throw new Error(errMsg);
          }
          return body;
        });
      });
    }

    addPromise
      .then(function () {
        var title =
          (btn.getAttribute('data-product-title') || btn.dataset.productTitle || 'Item').trim() || 'Item';
        var msg = title + ' added';
        announceStep3(scopedRoot, msg);
        showStickyVariantChip(scopedRoot, msg);
        updateBundleStep3Choice(scopedRoot, title);

        btn.textContent = 'Added ✓';
        btn.classList.add('lp-step3-card__add--added');
        setTimeout(function () {
          btn.textContent = originalLabel;
          btn.classList.remove('lp-step3-card__add--added');
        }, 1800);

        if (card) {
          card.classList.add('lp-step3-card--added');
          if (!reduceMotion) {
            card.classList.remove('lp-step3-card--sparkle');
            void card.offsetWidth;
            card.classList.add('lp-step3-card--sparkle');
            setTimeout(function () { card.classList.remove('lp-step3-card--sparkle'); }, 920);
          }
        }
        syncAtcPriceDisplay(scopedRoot);
      })
      .catch(function (err) {
        var msg = err && err.message ? err.message : 'Could not add. Try again.';
        showStickyVariantChip(scopedRoot, msg);
      })
      .finally(function () {
        btn.removeAttribute('aria-busy');
        btn.removeAttribute('disabled');
        btn.classList.remove('is-loading');
      });
  }

  let lpCartAtcSyncBound = false;

  function bindLpCartAtcSyncOnce() {
    if (lpCartAtcSyncBound) return;
    lpCartAtcSyncBound = true;
    document.addEventListener('liquid-ajax-cart:request-end', function (ev) {
      const detail = ev && ev.detail;
      if (!detail || !detail.responseData || !detail.responseData.ok) return;
      getSectionRoots().forEach(function (root) {
        if (root.querySelector('.lp-step3-card--added')) {
          syncAtcPriceDisplay(root);
        }
      });
    });
  }

  function bindLpStep3AddDocumentOnce() {
    if (lpStep3AddDocBound) return;
    lpStep3AddDocBound = true;
    bindLpCartAtcSyncOnce();
    document.addEventListener(
      'click',
      function (e) {
        const btn = e.target.closest && e.target.closest('.js-lp-step3-add');
        if (!btn) return;
        handleStep3AddClick(btn, e);
      },
      true
    );
  }

  function initBundleStepReopenControls(root) {
    const scopedRoot = normalizeRoot(root);
    scopedRoot.querySelectorAll('.js-bundle-step-reopen-step1').forEach(function (btn) {
      if (btn.dataset.lpBundleReopenBound === '1') return;
      btn.dataset.lpBundleReopenBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const r = getSectionRoot(btn);
        const d1 = r.querySelector('#lp-bundle-details-1');
        const d2 = r.querySelector('#lp-bundle-details-2');
        const d3 = r.querySelector('#lp-bundle-details-3');
        if (d2) d2.open = false;
        if (d3) d3.open = false;
        if (d1) {
          d1.open = true;
          try {
            d1.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          } catch (_err) {
            d1.scrollIntoView();
          }
          const sm = d1.querySelector('summary');
          if (sm && typeof sm.focus === 'function') {
            try {
              sm.focus();
            } catch (_err) {
              /* ignore */
            }
          }
        }
        updateBundleStepPill(r);
      });
    });
  }

  // ─── INIT ON DOM READY ───
  /** Default the shade picker to Medium (first available) so there is no
   *  unselected state; syncs prices, education panel and step labels. */
  function initDefaultShadeSelection(root) {
    const scopedRoot = normalizeRoot(root);
    let card = scopedRoot.querySelector('.shade-card.selected');
    if (!card || !isShadeAvailable(card)) {
      const cards = Array.from(scopedRoot.querySelectorAll('.shade-card'));
      card =
        cards.find((c) => /medium/i.test(c.dataset.shade || '') && isShadeAvailable(c)) ||
        cards.find((c) => isShadeAvailable(c)) ||
        null;
    }
    if (card && card.dataset.shade) selectShade(card.dataset.shade, scopedRoot, false);
  }

  /** "Next step" CTA beside FIND MY SHADE: advance to Step 3 (or the ATC). */
  function initShadeNextStepButtons() {
    document.querySelectorAll('.js-shade-next-step').forEach((btn) => {
      if (btn.dataset.lpNextStepBound === '1') return;
      btn.dataset.lpNextStepBound = '1';
      btn.addEventListener('click', function () {
        const scopedRoot = normalizeRoot(getSectionRoot(this));
        if (scopedRoot.querySelector('#lp-bundle-details-3')) {
          openStep3AfterShadeSelect(scopedRoot);
          return;
        }
        const d2 = scopedRoot.querySelector('#lp-bundle-details-2');
        if (d2) d2.open = false;
        scrollTo('main-atc', this);
      });
    });
  }

  function init() {
    initShadeQuizLightbox();

    reparentBottomStickyToBody();
    getSectionRoots().forEach((root) => {
      initStickySummaryToggle(root);
    });

    // Initialize countdown timer
    initCountdown();

    // Initialize before/after slider
    initBeforeAfter();

    // Sticky in-page section nav
    initAnchorNav();

    // Hide the masthead once the user scrolls past the press bar
    // ("AS FEATURED IN") so the bottom sticky CTA owns conversion.
    initHeaderVisibilityAfterPressBar();
    updateChromeHeight();

    // Tap-to-copy the promo code with visible "Copied!" feedback.
    initCodeBannerCopy();

    // Initialize FAQ
    initFAQ();

    // Bundle selection handlers
    document.querySelectorAll('.bundle-card').forEach(card => {
      if (card.dataset.lpBundleClickBound === '1') return;
      card.dataset.lpBundleClickBound = '1';
      card.addEventListener('click', function() {
        const bundle = parseInt(this.dataset.bundle);
        if (!isNaN(bundle)) {
          selectBundle(bundle, true, getSectionRoot(this));
        }
      });
    });

    // Shade selection handlers
    document.querySelectorAll('.shade-card').forEach(card => {
      if (card.dataset.lpShadeClickBound === '1') return;
      card.dataset.lpShadeClickBound = '1';
      card.addEventListener('click', function() {
        const shade = this.dataset.shade;
        if (shade) {
          selectShade(shade, getSectionRoot(this), true);
        }
      });
    });

    // "Next step" buttons in the shade step
    initShadeNextStepButtons();

    // FAQ handlers
    document.querySelectorAll('.faq-item').forEach(item => {
      if (item.dataset.lpFaqClickBound === '1') return;
      item.dataset.lpFaqClickBound = '1';
      item.addEventListener('click', function() {
        toggleFaq(this);
      });
    });

    // Add to cart handlers
    const mainATC = document.getElementById('main-atc');
    if (mainATC) {
      mainATC.addEventListener('click', addToCart);
    }

    const stickyATC = document.getElementById('sticky-atc');
    if (stickyATC) {
      stickyATC.addEventListener('click', addToCart);
    }

    // Scroll to bundle handlers
    document.querySelectorAll('a[href="#bundle"]').forEach(a => {
      if (a.dataset.lpBundleScrollBound === '1') return;
      a.dataset.lpBundleScrollBound = '1';
      a.addEventListener('click', e => {
        e.preventDefault();
        scrollTo('bundle', a);
      });
    });

    getSectionRoots().forEach((root) => {
      removeLegacyMainRowStickyVariantChips(root);
      initBundleStepReopenControls(root);
      initBundleDetailsStepPillSync(root);
      initStepThreeUpsell(root);
      initBundlesFromSchema(root);
      syncBundleCardsFromSelectedVariant(root);
      syncBundleImagesFromSelectedVariant(root);

      ensureAvailableShadeSelection(root);
      initDefaultShadeSelection(root);
      hideStickyVariantChip(root);

      const preBundle =
        root.querySelector('.bundle-card.selected') ||
        root.querySelector('.bundle-card[data-bundle="2"]') ||
        root.querySelector('.bundle-card');
      if (preBundle) {
        const bundle = parseInt(preBundle.dataset.bundle, 10);
        if (getBundleTiers(root)[String(bundle)]) setCurrentBundle(root, bundle);
        selectBundle(getCurrentBundle(root), false, root);
      }
      syncShadeEducationPanel(root);
    });
  }

  // ─── CHROME HEIGHT ───
  // Measures the actual stacked height of sticky ann-bar + masthead and writes
  // --lp-ann-height and --lp-chrome-height to :root so the masthead top offset
  // and all scroll anchors stay pixel-perfect across every screen size and copy length.
  function updateChromeHeight() {
    const annBar   = document.querySelector('.ann-bar');
    const masthead = document.querySelector('.lp-cg-masthead');
    const annH = annBar   ? annBar.getBoundingClientRect().height   : 0;
    const navH = masthead ? masthead.getBoundingClientRect().height : 0;
    const total = annH + navH;

    const root = document.documentElement;
    if (annH > 0) {
      root.style.setProperty('--lp-ann-height', annH + 'px');
    }
    if (total > 0) {
      root.style.setProperty('--lp-chrome-height', total + 'px');
      root.style.setProperty('--lp-scroll-anchor-offset', total + 'px');
    }
  }

  if (typeof ResizeObserver !== 'undefined') {
    const chromeObserver = new ResizeObserver(updateChromeHeight);
    document.querySelectorAll('.ann-bar, .lp-cg-masthead').forEach(el => chromeObserver.observe(el));
  }
  updateChromeHeight();
  window.addEventListener('resize', updateChromeHeight);

  // Run on DOM ready
  window.__bbeLpCleanGlowInit = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    const section = event.target;
    if (!section || !section.querySelectorAll) return;
    teardownBeforeAfterInSubtree(section);
    if (!section.matches || !section.matches(CLEAN_GLOW_SECTION_SELECTOR)) return;
    teardownStickySummaryToggle(section);
    hideStickyVariantChip(section);
    removeReparentedStickyForRoot(section);
    sectionState.delete(section);
    if (activeCleanGlowRoot === section) activeCleanGlowRoot = null;
    teardownHeaderVisibilityAfterPressBar();
  });

  // Expose functions globally for inline onclick handlers (if needed)
  window.selectBundle = selectBundle;
  window.selectShade = selectShade;
  window.toggleFaq = toggleFaq;
  window.filterRevs = filterRevs;
  window.lpScrollTo = function (id, source) {
    return scrollTo(id, source || getScrollSource());
  };

})();
